import {Component} from '@angular/core';
import {MdSnackBar} from '@angular/material';
/**
 * \@title Snack-bar with a custom component
 */
export class SnackBarComponentExample {
/**
 * @param {?} snackBar
 */
constructor(public snackBar: MdSnackBar) {}
/**
 * @return {?}
 */
openSnackBar() {
    this.snackBar.openFromComponent(PizzaPartyComponent, {
      duration: 500,
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'snack-bar-component-example',
  templateUrl: 'snack-bar-component-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdSnackBar, },
];
}

function SnackBarComponentExample_tsickle_Closure_declarations() {
/** @type {?} */
SnackBarComponentExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SnackBarComponentExample.ctorParameters;
/** @type {?} */
SnackBarComponentExample.prototype.snackBar;
}

export class PizzaPartyComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'snack-bar-component-example-snack',
  templateUrl: 'snack-bar-component-example-snack.html',
  styleUrls: ['snack-bar-component-example-snack.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PizzaPartyComponent_tsickle_Closure_declarations() {
/** @type {?} */
PizzaPartyComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PizzaPartyComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
